import React, { Component } from 'react';
import { browserHistory, Link } from 'react-router';
import {
  reduxForm, Field, reset, change
} from 'redux-form';
import Select2 from 'react-select2-wrapper';
import moment from 'moment';
import Header from '../../components/Header';
import { renderField } from '../../helpers/form-validations';
import withUser from '../../common/withUser';
import withGoBack from '../../common/withGoBack';
import withNotify from '../../common/withNotify';
import withSearchBilledData from '../../common/withSearchBilledData';
import withSearchBilledCaseCountData from '../../common/withSearchBilledCaseCountData';
import withOnline from '../../common/withOnline';
import withLoader from '../../common/withLoader';
import withTableName from '../../common/withTableName';
import {
  formatter,
  getNoneAtTop,
  onGoBack,
  sortData
} from '../../common/globals';
import withTeam from '../../common/withTeam';
import {
  getProcedureTypes,
  getSideType,
  getSurgeons,
  getTeamReps,
  setBilledCases,
  getHospitals,
  getAltCaseTypes
} from '../../utils/db';
import { searchBilled } from '../../utils/utils';
import Bugsnag from '../../helpers/bugsnag';
import FilterAccordionItem from '../../components/FilterAccordionItem.js';
import OptimizeDatePicker from '../../components/commonComponents/OptimizeDatePicker';

const initialValues = {
  repName: '',
  addNotes: '',
  hospital: '',
  MRN: '',
  officeNotes: '',
  PatientID: '',
  po: '',
  procedure: '',
  side: '',
  type: '',
};

class SearchBilled extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: [],
      surgeon: [],
      hospital: [],
      procedure: [],
      side: [],
      coverRep: [],
      DateStart: '',
      DateEnd: '',
      selectedTypes: [],
      selectSurgeon: [],
      selectHospitals: [],
      selectedProcedures: [],
      Side: [],
      selectedRefs: '',
      totalCases: 0,
      totalAmount: 0,
      searchFormData: {},
      billedCases: [],
      hideAndShowCard: false
    };
  }

  componentDidMount() {
    try {
      document.getElementById('date-picker-input').setAttribute('readonly', 'readonly');
      document.getElementById('date-picker-input2').setAttribute('readonly', 'readonly');
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSubmit = (formData) => {
    try {
      const { online, notify, setSearchBilledData } = this.props;
      const {
        DateStart, DateEnd, selectedTypes, selectSurgeon,
        selectHospitals, selectedProcedures,
        Side, selectedRefs
      } = this.state;

      if (DateStart !== undefined || DateEnd !== undefined) {
        if ((DateStart === '' || DateEnd === undefined)
          && (DateEnd !== '')) {
          notify({ type: 'error', message: 'Please select start date' });
          return;
        }
      }

      if (selectedTypes === 'NONE') {
        this.setState({ selectedTypes: [] });
      }
      if (selectedRefs === 'NONE') {
        this.setState({ selectedRefs: '' });
      }

      const {
        officeNotes, RepNotes, po, PatientID, MRN,
      } = formData;
      const startDate = DateStart !== ''
        ? moment(DateStart).format('YYYY/MM/DD')
        : '';
      const endDate = DateEnd !== ''
        ? moment(DateEnd).format('YYYY/MM/DD')
        : '';
      setSearchBilledData({
        selected: {
          DateStart: startDate,
          DateEnd: endDate,
          selectedTypes,
          selectSurgeon,
          selectHospitals,
          selectedProcedures,
          Side,
          selectedRefs
        },
        form: {
          officeNotes,
          RepNotes,
          po,
          PatientID,
          MRN,
        }
      });
      if (online) {
        this.setState({ searchFormData: formData }, async () => {
          await this._getBilledCases('Y');
        });
      } else {
        notify({
          type: 'error',
          message: 'You must have as internet connection. Please check your connection and try again.',
          time: 3
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getBilledCases = async (isCount) => {
    try {
      const {
        DateStart,
        selectSurgeon,
        DateEnd,
        selectHospitals,
        selectedTypes,
        selectedProcedures,
        Side,
        selectedRefs,
        searchFormData
      } = this.state;
      const {
        notify, setLoader, online, setSearchBilledCaseCountData
      } = this.props;

      const startDate = DateStart !== ''
        ? moment(DateStart).format('YYYY/MM/DD')
        : '';
      const endDate = DateEnd !== ''
        ? moment(DateEnd).format('YYYY/MM/DD')
        : '';
      const po = searchFormData.hasOwnProperty('po')
        ? searchFormData.po : '';
      const PatientID = searchFormData.hasOwnProperty('PatientID')
        ? searchFormData.PatientID : '';
      const RepNotes = searchFormData.hasOwnProperty('RepNotes')
        ? searchFormData.RepNotes : '';
      const officeNotes = searchFormData.hasOwnProperty('officeNotes')
        ? searchFormData.officeNotes : '';
      const MRN = searchFormData.hasOwnProperty('MRN')
        ? searchFormData.MRN : '';

      if (online) {
        const searchData
          = `SearchType=billed&GetCountOnly=${isCount}&DateStart=${startDate}&DateEnd=${endDate}
      &SurgeonName=${selectSurgeon ? JSON.stringify(selectSurgeon) : []}
      &Hospital=${selectHospitals ? JSON.stringify(selectHospitals) : []}
      &AltCaseType=${selectedTypes ? JSON.stringify(selectedTypes) : []}
      &ProcedureType=${selectedProcedures ? JSON.stringify(selectedProcedures) : []}
      &Side=${Side ? JSON.stringify(Side) : []}
      &PatientID=${PatientID ? JSON.stringify([PatientID]) : []}
      &CoverRep=${selectedRefs ? JSON.stringify([selectedRefs]) : []}
      &RepNotes=${typeof RepNotes !== 'undefined' ? RepNotes : ''}&Comments=${officeNotes}  
      &RepPONumber=${po}&MRN=${MRN}`;

        setLoader(true);
        await searchBilled(searchData).then(async (response) => {
          const { status, message, data } = response;
          if (status) {
            setLoader(false);
            if (!response.hasOwnProperty('data')) {
              notify({ type: 'error', message });
              return;
            }
            if (data.totalCases > 500) {
              notify({ type: 'error', message });
              this.setState({
                totalCases: data.totalCases,
                totalAmount: data.totalAmount,
              });
              return;
            }
            this.setState({
              totalCases: data.totalCases,
              totalAmount: data.totalAmount,
              billedCases: data.hasOwnProperty('cases') ? data.cases : []
            });
            setSearchBilledCaseCountData({
              totalCases: data.totalCases,
              totalAmount: data.totalAmount
            });
            if (data.totalCases === 0) {
              notify({ type: 'error', message, time: 2 });
            }

            // set case into local db
            await setBilledCases(this.state.billedCases);
          } else {
            notify({ type: 'warning', message, time: 5 });
          }
        });
      } else {
        notify({
          type: 'error',
          message: 'You must have as internet connection. Please check your connection and try again.',
          time: 3
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickReset = () => {
    try {
      const { dispatch, setSearchBilledData, setSearchBilledCaseCountData } = this.props;
      dispatch(reset('searchBilledForm'));
      this.setState({
        totalCases: 0,
        totalAmount: 0,
        DateStart: '',
        DateEnd: '',
        selectedTypes: [],
        selectSurgeon: [],
        selectHospitals: [],
        selectedProcedures: [],
        Side: [],
        selectedRefs: '',
      });
      setSearchBilledData({});
      setSearchBilledCaseCountData({});
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getHospital = async () => {
    try {
      const hospitalRes = await getHospitals();
      const sortHospitals = sortData(hospitalRes, 'CustomerName');
      this.setState({
        hospital: sortHospitals
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getSurgeon = async () => {
    try {
      const surgeonRes = await getSurgeons();
      const sortSurgeons = sortData(surgeonRes, 'SurgeonName');
      this.setState({
        surgeon: sortSurgeons
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getProcedureTypes = async () => {
    try {
      const procedureTypesRes = await getProcedureTypes();
      this.setState({
        procedure: procedureTypesRes
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getCaseType = async () => {
    try {
      const altCaseTypesRes = await getAltCaseTypes();
      const sortType = sortData(altCaseTypesRes, 'AltCaseType');
      this.setState({
        type: sortType
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getSideType = async () => {
    try {
      const sideTypeRes = await getSideType();
      const sortSideType = sortData(sideTypeRes, 'OptionName');
      const sideSortByNoneRes = await getNoneAtTop(sortSideType, 'OptionName');
      this.setState({
        side: sideSortByNoneRes
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getTeamReps = async () => {
    try {
      const { user: { userId }, team: { salesAccess } } = this.props;
      const teamRepsRes = await getTeamReps();
      salesAccess && teamRepsRes.push({ SalesRepName: salesAccess ? userId : '' });
      const sortTeamReps = sortData(teamRepsRes, 'SalesRepName');
      sortTeamReps.unshift({ SalesRepName: 'NONE' });
      this.setState({
        coverRep: sortTeamReps
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onMonthToDate = () => {
    try {
      this.setState({
        DateStart: moment().startOf('month').toDate(),
        DateEnd: moment().toDate()
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onYearToDate = () => {
    try {
      this.setState({
        DateStart: moment().startOf('year').toDate(),
        DateEnd: moment().toDate()
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onViewCases = async () => {
    try {
      await this._getBilledCases('N');
      this._onGoBack();
      browserHistory.push('/billed');
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onRedirect = (path) => {
    try {
      this._onGoBack();
      browserHistory.push(path);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onGoBack = () => {
    try {
      const { goBack, setGoBack } = this.props;
      goBack.push(window.location.pathname);
      setGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _goBack = () => {
    try {
      const {
        goBack, setTableName, setSearchBilledData, setSearchBilledCaseCountData
      } = this.props;
      setTableName('Cases');
      setSearchBilledData({});
      setSearchBilledCaseCountData({});
      onGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClearField = (field) => {
    try {
      const {
        searchBilledData,
        setSearchBilledData
      } = this.props;
      const newState = {};
      newState[field] = [];
      this.setState(newState, () => {
        setSearchBilledData({
          selected: { ...searchBilledData.selected, ...newState },
          form: searchBilledData.form,
        });
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  async UNSAFE_componentWillMount() {
    try {
      const {
        team: { salesAccess }, searchBilledData, dispatch, searchBilledCaseCountData
      } = this.props;

      if (!salesAccess) {
        browserHistory.push('/manage-cases');
      }
      await this._getSurgeon();
      await this._getHospital();
      await this._getCaseType();
      await this._getProcedureTypes();
      await this._getTeamReps();
      await this._getSideType();

      if (Object.keys(searchBilledData).length > 0) {
        Object.keys(searchBilledData.form).map((key) => {
          dispatch(change('searchBilledForm', key, searchBilledData.form[key]));
        });
      }

      this.setState({
        ...this.state,
        ...searchBilledData.selected,
        ...searchBilledData.form,
        ...searchBilledCaseCountData
      });

      this.setState({ searchFormData: searchBilledData.form });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const { handleSubmit } = this.props;
    const {
      DateEnd, DateStart, type,
      selectedTypes, surgeon,
      selectSurgeon, hospital,
      selectHospitals, procedure,
      selectedProcedures, side, Side, coverRep,
      selectedRefs,
      totalCases, totalAmount,
    } = this.state;
    return (
      <div className="site-wrapper">
        <form onSubmit={handleSubmit(this._onSubmit)} form="searchBilledForm">
          <Header
            title="Search Billed Cases"
            goBack={this._goBack}
            // actionButton={{ type: 'button', title: 'Reset', onClick: this._onClickReset }}
            actionButton={{ title: 'Execute' }}
          />

          <section className="top-filter-section border-top-0">
            <div className="container">
              <div className="row">
                <div className="col">
                  <p>Cases: {totalCases}</p>
                </div>
                <div className="col text-end">
                  <p>Total: {formatter.format(totalAmount)}</p>
                </div>
              </div>
            </div>
          </section>

          <>
            <section className="case-details-section pb-5 mb-4">
              <div className="container">
                <div className="row g-3 mb-3">
                  <div className="col-6">
                    <Link className="btn btn-theme-alt btn-theme-outline-alt w-100" onClick={this._onMonthToDate}>Month-to-Date</Link>
                  </div>
                  <div className="col-6">
                    <Link className="btn btn-theme-alt btn-theme-outline-alt w-100" onClick={this._onYearToDate}>Year-to-Date</Link>
                  </div>
                </div>
                <div className="row gx-2 accordion-filter accordion-flush">
                  <div className="col-12 accordion-item">
                    <div className="accordion-header">
                      <button className="button collapsed-remove" type="button">
                        Time Period
                      </button>
                    </div>
                    <div className="accordion-collapse">
                      <div className="accordion-body pt-0 row gx-2">
                        <div className="col-6">
                          <OptimizeDatePicker
                            dateFormat="MM/dd/yyyy"
                            className="form-control date-picker-read-only"
                            id="date-picker-input"
                            placeholderText="Start Date"
                            onChangeRaw={(e) => {
                              e.preventDefault();
                            }}
                            maxDate={DateEnd}
                            selected={DateStart !== '' ? moment(DateStart).toDate() : ''}
                            onChange={(value) => {
                              this.setState({ DateStart: value });
                            }}
                          />
                        </div>
                        <div className="col-6">
                          <OptimizeDatePicker
                            dateFormat="MM/dd/yyyy"
                            onChangeRaw={(e) => {
                              e.preventDefault();
                            }}
                            minDate={DateStart}
                            className="form-control date-picker-read-only"
                            id="date-picker-input2"
                            placeholderText="End Date"
                            selected={DateEnd !== '' ? moment(DateEnd).toDate() : ''}
                            onChange={(value) => {
                              this.setState({ DateEnd: value });
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <FilterAccordionItem
                    id="type-field"
                    title="Type"
                    className="col-12"
                    itemList={type.map((crtType) => crtType.AltCaseType)}
                    selectedItems={selectedTypes}
                    onChange={(value) => this.setState({ selectedTypes: value })}
                    onClear={() => this._onClearField('selectedTypes')}
                  />
                  <FilterAccordionItem
                    id="surgeon-field"
                    title="Surgeon"
                    className="col-12"
                    itemList={surgeon.map((surgeonRes) => (surgeonRes.SurgeonName))}
                    selectedItems={selectSurgeon}
                    onChange={(value) => this.setState({ selectSurgeon: value },
                      () => {
                        this._getHospital(value);
                      })}
                    onClear={() => this._onClearField('selectSurgeon')}
                  />
                  <FilterAccordionItem
                    onChange={(value) => this.setState({ selectHospitals: value })}
                    onClear={() => this._onClearField('selectHospitals')}
                    itemList={hospital.map((value) => value.CustomerName)}
                    id="hospital-field"
                    className="col-12"
                    title="Hospital"
                    selectedItems={selectHospitals}
                  />
                  <FilterAccordionItem
                    onChange={(value) => this.setState({ selectedProcedures: value })}
                    onClear={() => this._onClearField('selectedProcedures')}
                    itemList={procedure.map((value) => value.OptionName)}
                    id="procedure-field"
                    className="col-12"
                    title="Procedure"
                    selectedItems={selectedProcedures}
                  />
                  <FilterAccordionItem
                    onChange={(value) => this.setState({ Side: value })}
                    onClear={() => this._onClearField('Side')}
                    itemList={side.map((value) => value.OptionName)}
                    id="side-field"
                    className="col-12"
                    title="Side"
                    selectedItems={Side}
                  />
                  <div className="col-12 accordion-item">
                    <div className="accordion-header">
                      <button className="button collapsed-remove" type="button">
                        Patient
                      </button>
                    </div>
                    <div className="accordion-collapse">
                      <div className="accordion-body pt-0">
                        <Field
                          type="text"
                          name="PatientID"
                          className="form-control search-input search-input-focus"
                          placeholder="Patient"
                          component={renderField}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 accordion-item">
                    <div className="accordion-header">
                      <button className="button collapsed-remove" type="button">
                        MRN
                      </button>
                    </div>
                    <div className="accordion-collapse">
                      <div className="accordion-body pt-0">
                        <Field
                          type="text"
                          name="MRN"
                          className="form-control search-input search-input-focus"
                          placeholder="#"
                          component={renderField}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 accordion-item">
                    <div className="accordion-header">
                      <button className="button collapsed-remove" type="button">
                        PO#
                      </button>
                    </div>
                    <div className="accordion-collapse">
                      <div className="accordion-body pt-0">
                        <Field
                          type="text"
                          name="po"
                          className="form-control search-input search-input-focus"
                          placeholder="#"
                          component={renderField}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 accordion-item">
                    <div className="accordion-header">
                      <button className="button collapsed-remove" type="button">
                        Rep
                      </button>
                    </div>
                    <div className="accordion-collapse">
                      <div className="accordion-body pt-0">
                        <Select2
                          style={{ width: '100%' }}
                          className="form-control"
                          data={coverRep.map((value) => value.SalesRepName)}
                          onSelect={({ target: { value } }) => {
                            this.setState({ selectedRefs: value });
                          }}
                          value={selectedRefs !== 'NONE' ? selectedRefs : ''}
                          options={{ placeholder: 'Rep' }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 accordion-item">
                    <div className="accordion-header">
                      <button className="button collapsed-remove" type="button">
                        Rep Notes
                      </button>
                    </div>
                    <div className="accordion-collapse">
                      <div className="accordion-body pt-0">
                        <Field
                          type="textarea"
                          name="RepNotes"
                          className="form-control search-input search-input-focus"
                          placeholder="Add Notes"
                          component={renderField}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 accordion-item">
                    <div className="accordion-header">
                      <button className="button collapsed-remove" type="button">
                        Office Notes
                      </button>
                    </div>
                    <div className="accordion-collapse">
                      <div className="accordion-body pt-0">
                        <Field
                          type="textarea"
                          name="officeNotes"
                          className="form-control search-input search-input-focus"
                          placeholder="Add Notes"
                          component={renderField}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section className="sets-footer-section fixed-bottom">
              <div className="container">
                <div className="button-block">
                  <div className="row gx-2">

                    <div className="col-6">
                      <button
                        type="button"
                        className={`btn w-100 ${(totalCases !== 0 || totalCases <= 500) ? 'btn-theme-alt btn-theme-outline-alt' : 'button-disabled btn-theme-outline-alt'}`}
                        disabled={(totalCases === 0 || totalCases > 500)}
                        onClick={this._onViewCases}
                      >View Cases
                      </button>
                    </div>

                    <div className="col-6">
                      {/* <button
                        type="submit"
                        className="btn btn-theme-alt btn-theme-outline-alt w-100"
                      >
                        Search
                      </button> */}

                      <button
                        type="button"
                        className="btn btn-theme-alt btn-theme-outline-alt w-100"
                        onClick={this._onClickReset}
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </>
        </form>
      </div>
    );
  }
}

const withForm = reduxForm({
  form: 'searchBilledForm',
  initialValues,
});

export default withTableName(
  withLoader(
    withNotify(
      withOnline(
        withTeam(
          withSearchBilledData(
            withForm(
              withSearchBilledCaseCountData(
                withGoBack(
                  withUser(
                    SearchBilled
                  )
                )
              )
            )
          )
        )
      )
    )
  )
);
